var profile;
(function (profile) {
    document.addEventListener('ControllerReady', () => {
        const config = retrieveConfig(document);
        let isMobile = window.innerWidth < 992;
        let submitStatus = false;
        let tab;
        let updateProfileEndpoint = `/api/esb/user/updateProfile?_format=form`;
        let updatePrivacyEndpoint = `/api/esb/user/setPrivacy?_format=form`;
        let getProfileEndpoint = `/api/esb/user/getProfile?_format=form`;
        let getPrivacyEndpoint = `/api/esb/user/getPrivacyDisclaimers?_format=form`;
        let step_pers = document.querySelector('#step-pers');
        let step_coop = document.querySelector('#step-coop');
        let step_cons = document.querySelector('#step-cons');
        let profileEanCard = "";
        let profileBirthDate = "";
        const modificaForm = document.querySelector('.modificaForm');
        const divProfile = document.querySelector('.profile-div');
        let privacy_container = document.querySelector('#privacy-container');
        let $targets = privacy_container.querySelectorAll('.discl-remove');
        $targets.forEach(($target) => {
            $target.remove();
        });
        var token = getCookie('session_token');
        var coopId = getCookie('session_coopId');
        let email = modificaForm.querySelector('[name="email"]');
        let nome = modificaForm.querySelector('[name="nome"]');
        let cognome = modificaForm.querySelector('[name="cognome"]');
        let dataNascita = modificaForm.querySelector('[name="dataNascita"]');
        let eanCard = modificaForm.querySelector('[name="tessera"]');
        let gender = modificaForm.querySelector('[name="sesso"]');
        let tempDataNascita = modificaForm.querySelector('#coop-data-nascita');
        let residenceCity = modificaForm.querySelector('[name="cittaResidenza"]');
        let telefono = modificaForm.querySelector('[name="telefono"]');
        let cap = modificaForm.querySelector('[name="cap"]');
        let iconInfoTessera = modificaForm.querySelector('.info-tessera');
        iconInfoTessera.addEventListener('click', () => {
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.tessera-socio-modal');
            const $btnAccept = $modal.querySelector('.accept');
            $modal.classList.remove('d-none');
            $body.classList.add('scrollLock');
            $btnAccept.removeEventListener('click', () => { });
            $btnAccept.addEventListener('click', () => {
                $modal.classList.add('d-none');
                $body.classList.remove('scrollLock');
            });
        });
        let modifica_socio = modificaForm.querySelector('#modifica-carta-socio');
        modifica_socio.addEventListener('click', enable_socio);
        let modifica_pers = modificaForm.querySelector('#modifica-personal-data');
        modifica_pers.addEventListener('click', enable_pers);
        let btn_pers = document.querySelector('#btn-menu-pers');
        btn_pers.addEventListener('click', showPers);
        let btn_coop = document.querySelector('#btn-menu-coop');
        btn_coop.addEventListener('click', showCoop);
        let btn_cons = document.querySelector('#btn-menu-cons');
        btn_cons.addEventListener('click', showCons);
        let radio_socio_si = document.querySelector('#socio-si-radio');
        radio_socio_si.addEventListener('click', showCard);
        let radio_socio_no = document.querySelector('#socio-no-radio');
        radio_socio_no.addEventListener('click', hideCard);
        let logout = document.querySelector('#btn-logout-left');
        logout.addEventListener('click', logOut);
        let divLogNo = document.querySelector('.login-caller-no');
        let divLogYes = document.querySelector('.login-caller-yes');
        let privacyCoopItaliaProfile;
        const image_tessera_socio_general = "/sites/default/files/2025-06/carta_socio_general.png";
        const image_tessera_socio_etruria = "/sites/default/files/2025-06/carta_socio_etruria.png";
        const image_tessera_socio_etruria_desktop = "/sites/default/files/2025-06/carta_socio_etruria_desktop.png";
        let immagine_tessera_socio = setTesseraSocioModalImage();
        let enableEtruriaCaptionOnModal = coopId == '8';
        if (modificaForm)
            modificaForm.addEventListener('submit', handleFormSubmit);
        document.querySelector('.left-container-mobile').style.display = 'none';
        if (isMobile && mobileView()) {
            document.querySelector('.right-container').style.display = 'none';
            document.querySelector('.left-container').style.display = 'none';
            document.querySelector('.left-container-mobile').style.display = 'block';
        }
        init();
        function setTesseraSocioModalImage() {
            if (coopId == '8') {
                return isMobile ? image_tessera_socio_etruria : image_tessera_socio_etruria_desktop;
            }
            else {
                return image_tessera_socio_general;
            }
        }
        function mobileView() {
            const url = new URL(window.location.href);
            return url.searchParams.get('par') === 'val';
        }
        function init() {
            var _a, _b, _c, _d, _e, _f;
            if (getCookie('session_token') == '' || getCookie('session_coopId') == '') {
                window.location.href = '/auth/login';
            }
            if (!isMobile) {
                (_a = document.querySelector('#myevents-left-menu')) === null || _a === void 0 ? void 0 : _a.classList.remove('left-menu-selected');
                (_b = document
                    .querySelector('.my-events-margin-left')) === null || _b === void 0 ? void 0 : _b.classList.remove('margin-left-selected');
                (_c = document.querySelector('#myprofile-left-menu')) === null || _c === void 0 ? void 0 : _c.classList.add('left-menu-selected');
                (_d = document.querySelector('.profile-margin-left')) === null || _d === void 0 ? void 0 : _d.classList.add('margin-left-selected');
            }
            if (!isNazionale(coopId)) {
                (_e = document.querySelector('.cittaResidenza')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
                (_f = document.querySelector('.cap')) === null || _f === void 0 ? void 0 : _f.classList.add('d-none');
            }
            selectCooperativa(getCookie('session_coopId'));
            getProfile(getCookie('session_token'), getCookie('session_coopId'));
        }
        function handleFormSubmit(event) {
            event.preventDefault();
            divProfile.setAttribute('data-spinner', 'mask');
            modifica_socio.removeAttribute('disabled');
            modifica_pers.removeAttribute('disabled');
            let fields = document.querySelector('.input-data-pers').querySelectorAll('select, input');
            fields.forEach((field) => {
                field.setAttribute('disabled', '');
            });
            updateProfile();
        }
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function getProfile(token, coopId) {
            var url = { token: token, coopId: coopId };
            Fetch(getProfileEndpoint, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                var _a, _b, _c, _d, _e, _f;
                if (response.header.result == 'OK') {
                    email.value = response.payload.profile.email;
                    nome.value = response.payload.profile.name;
                    cognome.value = response.payload.profile.surname;
                    residenceCity.value = response.payload.profile.residenceCity;
                    cap.value = response.payload.profile.cap;
                    if (telefono.value.trim() != '') {
                        telefono.value = response.payload.profile.phone;
                    }
                    privacyCoopItaliaProfile = response.payload.privacyCoopItalia;
                    if (response.payload.profile.eanCard != null) {
                        profileEanCard = response.payload.profile.eanCard;
                        profileBirthDate = response.payload.profile.birthdate;
                        eanCard.value = response.payload.profile.eanCard;
                        eanCard.setAttribute('required', '');
                        eanCard.setAttribute('disabled', '');
                        tempDataNascita.setAttribute('disabled', '');
                        (_a = document.querySelector('.socio-choose')) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
                        if (getCookie('session_coopId') != '7') {
                            (_b = document
                                .querySelector('.modifica-carta-socio-div')) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
                        }
                    }
                    else {
                        (_c = document.querySelector('.socio-choose')) === null || _c === void 0 ? void 0 : _c.classList.remove('hidden');
                        (_d = document.querySelector('.socio-block')) === null || _d === void 0 ? void 0 : _d.classList.add('hidden');
                        radio_socio_no.checked = true;
                        if ((getCookie('session_coopId') == '7' && (getCookie('session_info').split('|').length < 7 || (getCookie('session_info').split('|').length > 6 && getCookie('session_info').split('|')[6] == 'N')))) {
                            radio_socio_si.setAttribute('disabled', '');
                            radio_socio_no.setAttribute('disabled', '');
                        }
                    }
                    if (response.payload.profile.gender != 'NULL' &&
                        response.payload.profile.gender != null) {
                        if (response.payload.profile.gender == 'M' ||
                            response.payload.profile.gender == 'Maschio') {
                            gender.value = 'Maschio';
                        }
                        else if (response.payload.profile.gender == 'F' ||
                            response.payload.profile.gender == 'Femmina') {
                            gender.value = 'Femmina';
                        }
                    }
                    else {
                        let parent = (_e = gender.parentNode) === null || _e === void 0 ? void 0 : _e.parentNode;
                        parent === null || parent === void 0 ? void 0 : parent.removeChild(gender.parentNode);
                    }
                    if (response.payload.profile.birthdate != null) {
                        dataNascita.valueAsDate = getCorrectDateFormat(response.payload.profile.birthdate);
                        tempDataNascita.valueAsDate = getCorrectDateFormat(response.payload.profile.birthdate);
                    }
                    else {
                        let parent = (_f = dataNascita.parentNode) === null || _f === void 0 ? void 0 : _f.parentNode;
                        parent === null || parent === void 0 ? void 0 : parent.removeChild(dataNascita.parentNode);
                    }
                    eanCard.addEventListener('input', checkAnagraficaCard);
                    eanCard.addEventListener('change', checkAnagraficaCard);
                    createDisclaimers(response);
                    document.querySelector('.profile-init').classList.add('hidden');
                    document.querySelector('.profile-div').classList.remove('hidden');
                }
                else {
                    var message = response.header.errorMessage;
                    console.error('Error: ', message);
                    if (response.header.errorCode == '206') {
                        logOut();
                    }
                    divProfile.removeAttribute('data-spinner');
                    showSaveModal('Errore caricamento dati profilo.');
                    document.querySelector('[name=btn-modale]').addEventListener('click', () => {
                        window.location.href = '/auth/login';
                    });
                }
            })
                .catch((err) => {
                console.error('Error: ', err);
                divProfile.removeAttribute('data-spinner');
            });
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function getCorrectDateTime(date) {
            let valoreData = date.value;
            let data = valoreData.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, function (match, y, m, d) {
                return d + '/' + m + '/' + y;
            });
            return data;
        }
        function isNazionale(coopId) {
            let ris = false;
            switch (coopId) {
                case '35':
                case '3':
                case '1':
                case '2':
                case '8':
                case '15':
                    break;
                default:
                    ris = true;
                    break;
            }
            return ris;
        }
        function getCorrectDateFormat(str) {
            const [day, month, year] = str.split('/');
            const date = new Date(+year, +month - 1, +day + 1);
            return date;
        }
        function updateProfile() {
            Fetch(updateProfileEndpoint, {
                method: 'POST',
                data: {
                    coopId: getCookie('session_coopId'),
                    token: getCookie('session_token'),
                    name: nome.value,
                    surname: cognome.value,
                    phone: telefono.value,
                    eanCard: eanCard.value,
                    birthdate: getCorrectDateTime(tempDataNascita),
                    gender: gender.value,
                    cap: cap.value,
                    residenceCity: residenceCity.value,
                    device: 'web',
                },
                token: { enable: true },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    updatePrivacy();
                    modifica_pers.removeAttribute('disabled');
                    modifica_socio.removeAttribute('disabled');
                    document.querySelector('.buttonContainer').classList.add('hidden');
                }
                else {
                    console.log('Errore nella chiamata a servizio updateProfile: ' +
                        response.header.errorMessage);
                    submitStatus = true;
                    if (response.header.errorCode == '16' || response.header.errorCode == '215') {
                        showSaveModal(response.header.errorMessage);
                        eanCard.value = profileEanCard;
                        tempDataNascita.valueAsDate = getCorrectDateFormat(profileBirthDate);
                    }
                    else if (response.header.errorCode == '17' ||
                        response.header.errorCode == '206') {
                        showSaveModal('Sessione scaduta.');
                        document.querySelector('[name=btn-modale]').addEventListener('click', () => {
                            window.location.href = '/auth/login';
                        });
                    }
                    else if (response.header.errorCode == '211') {
                        showSaveModal("Non è stato possibile aggiornare i dati inseriti. Verificare i dati inseriti e di essere l'instestatario della tessera");
                        eanCard.value = profileEanCard;
                        tempDataNascita.valueAsDate = getCorrectDateFormat(profileBirthDate);
                    }
                    else {
                        showSaveModal('Errore nel salvataggio del profilo.');
                    }
                    divProfile.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                console.error('Error: ', err);
                divProfile.removeAttribute('data-spinner');
                submitStatus = false;
            });
        }
        function updatePrivacy() {
            let privacyCoopItalia = getPrivacyString();
            var url = {
                coopId: getCookie('session_coopId'),
                token: getCookie('session_token'),
                privacyCoopItalia: privacyCoopItalia,
            };
            Fetch(updatePrivacyEndpoint, {
                method: 'POST',
                data: url,
                token: { enable: true },
            })
                .then((response) => {
                var _a, _b;
                if (response && response.header.result === 'OK') {
                    submitStatus = false;
                    showDiv(tab);
                    divProfile.removeAttribute('data-spinner');
                    if (eanCard.value != '') {
                        eanCard.setAttribute('disabled', '');
                        tempDataNascita.setAttribute('disabled', '');
                        (_a = document.querySelector('.socio-choose')) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
                        if (getCookie('session_coopId') != '7') {
                            (_b = document.querySelector('.modifica-carta-socio-div')) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
                        }
                    }
                    showSaveModal('Profilo salvato correttamente.');
                }
                else {
                    console.log('Errore nella chiamata a servizio updatePrivacy: ' +
                        JSON.parse(response['data']).header.errorMessage);
                    divProfile.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                divProfile.removeAttribute('data-spinner');
            });
        }
        function createDisclaimers(result) {
            var socio = result.payload.profile.eanCard != null ? 1 : 0;
            var coopidPrivacy = coopId;
            var url = { coopId: coopidPrivacy, userType: socio };
            do {
            } while (privacyCoopItaliaProfile == undefined);
            Fetch(getPrivacyEndpoint, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                var _a;
                var privacy_container = document.querySelector('#privacy-container');
                document.getElementById('siNazionaleLabelDisclaimer').innerHTML =
                    response.payload.privacyLabel;
                (_a = document
                    .getElementById('siNazionaleLinkDisclaimer')) === null || _a === void 0 ? void 0 : _a.setAttribute('href', response.payload.privacyLink);
                document.getElementById('check-view').checked = true;
                document.getElementById('check-view').disabled = true;
                var node = document.querySelector('.entry-profile');
                let indexDiscl;
                for (let i = 0; i < response.payload.optinPrivacy.length; i++) {
                    var obj = node.cloneNode(true);
                    obj.id = 'discl-' + i;
                    obj.classList.add('discl-remove');
                    var text = obj.querySelector('.li-entry');
                    text.innerHTML = response.payload.optinPrivacy[i].text;
                    var radioSi = document.createElement('input');
                    radioSi.setAttribute('type', 'radio');
                    radioSi.setAttribute('name', response.payload.optinPrivacy[i].id);
                    radioSi.setAttribute('value', 'true');
                    radioSi.setAttribute('id', 'privacy-ok-' + i);
                    radioSi.addEventListener('change', showSalvaButton);
                    radioSi.classList.add('radio-ok-privacy');
                    radioSi.classList.add('mandatory');
                    var labelText;
                    if (response.payload.optinPrivacy[i].mandatory) {
                        labelText = 'Accetto<sup>*</sup>';
                    }
                    else {
                        labelText = 'Accetto';
                    }
                    var labelSi = document.createElement('label');
                    labelSi.htmlFor = 'privacy-ok-' + i;
                    labelSi.innerHTML = labelText;
                    labelSi.style.marginRight = '20px';
                    var radioNo = document.createElement('input');
                    radioNo.setAttribute('type', 'radio');
                    radioNo.setAttribute('name', response.payload.optinPrivacy[i].id);
                    radioNo.setAttribute('value', 'false');
                    radioNo.setAttribute('id', 'privacy-ko-' + i);
                    radioNo.addEventListener('change', showSalvaButton);
                    radioNo.classList.add('radio-no-privacy');
                    var labelNo = document.createElement('label');
                    labelNo.htmlFor = 'privacy-ko-' + i;
                    labelNo.innerHTML = 'Non Accetto';
                    var divRadio = obj.querySelector('.divRadio');
                    divRadio.appendChild(radioSi);
                    divRadio.appendChild(labelSi);
                    divRadio.appendChild(radioNo);
                    divRadio.appendChild(labelNo);
                    indexDiscl = privacyCoopItaliaProfile.findIndex((privacy) => privacy.id == response.payload.optinPrivacy[i].id);
                    if (privacyCoopItaliaProfile.findIndex((privacy) => privacy.id == response.payload.optinPrivacy[i].id) != -1) {
                        if (privacyCoopItaliaProfile[indexDiscl].value == 'true') {
                            radioSi.setAttribute('checked', 'true');
                        }
                        else {
                            radioNo.setAttribute('checked', 'true');
                        }
                    }
                    if (response.payload.optinPrivacy[i].benefits !== undefined &&
                        response.payload.optinPrivacy[i].benefits.length > 0) {
                        var divBenefit = document.createElement('div');
                        divBenefit.classList.add('benefit');
                        divBenefit.classList.add('hidden');
                        divBenefit.id = 'divBen-' + i;
                        var divBenefitCol = document.createElement('div');
                        divBenefitCol.classList.add('col-12');
                        divBenefitCol.classList.add('coop-card-appartenza');
                        var ulBenefit = document.createElement('ul');
                        ulBenefit.id = 'ul-benefit';
                        ulBenefit.style.listStyle = 'none';
                        ulBenefit.classList.add('fa-ul'); 
                        for (let j = 0; j < response.payload.optinPrivacy[i].benefits.length; j++) {
                            var n = response.payload.optinPrivacy[i].benefits[j];
                            var linkBenefit = document.createElement('li');
                            linkBenefit.classList.add('labelField');
                            linkBenefit.style.marginBottom = '10px';
                            var span = document.createElement('span');
                            span.classList.add('fa-li');
                            var icon = document.createElement('i');
                            icon.classList.add('fas');
                            icon.classList.add('fa-check');
                            icon.classList.add('labelField');
                            icon.style.color = '#e30613';
                            span.appendChild(icon);
                            var textBenefit = document.createElement('p');
                            textBenefit.style.marginRight = '20px';
                            textBenefit.innerHTML = n.text + '<br>';
                            linkBenefit.appendChild(span);
                            linkBenefit.appendChild(textBenefit);
                            ulBenefit.appendChild(linkBenefit);
                        }
                        divBenefitCol.appendChild(ulBenefit);
                        divBenefit.appendChild(divBenefitCol);
                        obj.appendChild(divBenefit);
                        obj.style.padding = '10px';
                    }
                    obj.removeAttribute('hidden');
                    privacy_container.appendChild(obj);
                }
                divProfile.removeAttribute('data-spinner');
            })
                .catch((err) => {
                console.log(err);
            });
        }
        function getPrivacyString() {
            var result = '';
            var privacy_container = document.querySelector('#privacy-container');
            var checkboxes = privacy_container.querySelectorAll('input[type=radio]:checked');
            for (let i = 0; i < checkboxes.length; i++) {
                var temp = checkboxes[i];
                result += 'id:' + temp.name + ',value:' + temp.value + ';';
            }
            return result;
        }
        function checkAnagraficaCard() {
            var errorLab = document.querySelector('#errorLabelTessera');
            var boxErroreTessera = document.querySelector('.tessera-socio-error');
            var birthdate = document.querySelector('[name="dataNascita"]');
            errorLab.innerHTML = '';
            boxErroreTessera.classList.add('hidden');
            if (eanCard.value.length == 8 || eanCard.value.length == 13 ||
                eanCard.value.length == 0) {
                errorLab.innerHTML = '';
                boxErroreTessera.classList.add('hidden');
            }
            else if (eanCard.value.length > 0) {
                var message = '*Il numero della tessera socio non è corretto';
                errorLab.innerHTML = message;
                boxErroreTessera.classList.remove('hidden');
            }
            document.querySelector('.buttonContainer').classList.remove('hidden');
        }
        function enable_socio(event) {
            event.preventDefault();
            modifica_socio.setAttribute('disabled', '');
            submitStatus = true;
            document.querySelector('.buttonContainer').classList.remove('hidden');
            if (!(getCookie('session_coopId') == '7' && (getCookie('session_info').split('|').length < 7 || (getCookie('session_info').split('|').length > 6 && getCookie('session_info').split('|')[6] == 'N')))) {
                document.querySelector('#tessera-socio').removeAttribute('disabled');
                document.querySelector('#coop-data-nascita').removeAttribute('disabled');
            }
        }
        function enable_pers(event) {
            var _a;
            event.preventDefault();
            modifica_pers.setAttribute('disabled', '');
            submitStatus = true;
            let targets = document.querySelector('.input-data-pers').querySelectorAll('select, input');
            (_a = document.querySelector('.buttonContainer')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
            if (isNazionale(coopId)) {
                targets.forEach((target) => {
                    target.removeAttribute('disabled');
                });
            }
            else {
                targets.forEach((target) => {
                    if (target.getAttribute('immutable') === 'coop') {
                        target.removeAttribute('disabled');
                    }
                    if (target.name == "cap" || target.name == "cittaResidenza")
                        target.removeAttribute('required');
                });
            }
        }
        function showPers(event) {
            var _a, _b;
            event.preventDefault();
            enableStepRadios("step-pers");
            disableStepRadios("step-coop");
            disableStepRadios("step-cons");
            document.querySelector('.right-container').style.display = 'block';
            if (!isNazionale(coopId)) {
                (_a = document.querySelector('.cittaResidenza')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                (_b = document.querySelector('.cap')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            }
            if (submitStatus) {
                tab = 'pers';
                document.querySelector('.plus-sumbit-style').click();
            }
            else {
                tab = '';
                btn_pers.classList.add('selected');
                btn_coop.classList.remove('selected');
                btn_cons.classList.remove('selected');
                step_pers.removeAttribute('hidden');
                step_coop.setAttribute('hidden', '');
                step_cons.setAttribute('hidden', '');
            }
        }
        function showCoop(event) {
            event.preventDefault();
            disableStepRadios("step-pers");
            enableStepRadios("step-coop");
            disableStepRadios("step-cons");
            document.querySelector('.right-container').style.display = 'block';
            if (submitStatus) {
                tab = 'coop';
                document.querySelector('.plus-sumbit-style').click();
            }
            else {
                tab = '';
                btn_pers.classList.remove('selected');
                btn_coop.classList.add('selected');
                btn_cons.classList.remove('selected');
                step_pers.setAttribute('hidden', '');
                step_coop.removeAttribute('hidden');
                step_cons.setAttribute('hidden', '');
            }
        }
        function showCons(event) {
            event.preventDefault();
            disableStepRadios("step-pers");
            disableStepRadios("step-coop");
            enableStepRadios("step-cons");
            document.querySelector('.right-container').style.display = 'block';
            if (submitStatus) {
                tab = 'cons';
                document.querySelector('.plus-sumbit-style').click();
            }
            else {
                btn_pers.classList.remove('selected');
                btn_coop.classList.remove('selected');
                btn_cons.classList.add('selected');
                step_pers.setAttribute('hidden', '');
                step_coop.setAttribute('hidden', '');
                step_cons.removeAttribute('hidden');
            }
        }
        function showSalvaButton() {
            var _a;
            (_a = document.querySelector('.buttonContainer')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
            submitStatus = true;
        }
        function showSaveModal(msg) {
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.save-profile-modal');
            const $btnAccept = $modal.querySelector('.accept');
            document.querySelector('[name=title-modale-profile]').innerHTML = '';
            document.querySelector('[name=title-modale-profile]').innerHTML = msg;
            $modal.classList.remove('d-none');
            $body.classList.add('scrollLock');
            $btnAccept.removeEventListener('click', () => { });
            $btnAccept.addEventListener('click', () => {
                $modal.classList.add('d-none');
                $body.classList.remove('scrollLock');
            });
        }
        function showDiv(tab) {
            const clickEvent = new Event('click');
            switch (tab) {
                case 'pers':
                    showPers(clickEvent);
                    break;
                case 'coop':
                    showCoop(clickEvent);
                    break;
                case 'cons':
                    showCons(clickEvent);
                    break;
                default:
            }
        }
        function hideCard() {
            eanCard.removeAttribute('required');
            eanCard.value = '';
            var errorLab = document.querySelector('#errorLabelTessera');
            var boxErroreTessera = document.querySelector('.tessera-socio-error');
            errorLab.innerHTML = '';
            boxErroreTessera.classList.add('hidden');
            document.querySelector('.buttonContainer').classList.add('hidden');
            submitStatus = false;
            radio_socio_si.checked = false;
            radio_socio_no.checked = true;
            document.querySelector('.socio-block').classList.add('hidden');
        }
        function showCard() {
            var _a;
            eanCard.setAttribute('required', '');
            radio_socio_si.checked = true;
            radio_socio_no.checked = false;
            (_a = document.querySelector('.socio-block')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
            eanCard.removeAttribute('disabled');
            showSalvaButton();
        }
        function selectCooperativa(id) {
            let $filter;
            switch (id) {
                case '35':
                    $filter = document.querySelector('.CA3');
                    $filter.classList.remove('hidden');
                    break;
                case '9':
                    $filter = document.querySelector('.CCI');
                    $filter.classList.remove('hidden');
                    break;
                case '32':
                    $filter = document.querySelector('.CDR');
                    $filter.classList.remove('hidden');
                    break;
                case '29':
                    $filter = document.querySelector('.CTS');
                    $filter.classList.remove('hidden');
                    break;
                case '22':
                    $filter = document.querySelector('.CUA');
                    $filter.classList.remove('hidden');
                    break;
                case '44':
                    $filter = document.querySelector('.CDO'); 
                    $filter.classList.remove('hidden');
                    break;
                case '45':
                    $filter = document.querySelector('.MMC'); 
                    $filter.classList.remove('hidden');
                    break;
                case '36':
                    $filter = document.querySelector('.CTR'); 
                    $filter.classList.remove('hidden');
                    break;
                case '3':
                    $filter = document.querySelector('.CLO');
                    $filter.classList.remove('hidden');
                    break;
                case '1':
                    $filter = document.querySelector('.NOVA');
                    $filter.classList.remove('hidden');
                    break;
                case '7':
                    $filter = document.querySelector('.CFI');
                    $filter.classList.remove('hidden');
                    break;
                case '8':
                    $filter = document.querySelector('.CTI');
                    $filter.classList.remove('hidden');
                    break;
                case '2':
                    $filter = document.querySelector('.CLI');
                    $filter.classList.remove('hidden');
                    break;
                case '15':
                    $filter = document.querySelector('.CRO');
                    $filter.classList.remove('hidden');
                    break;
                case '17':
                    $filter = document.querySelector('.SAI');
                    $filter.classList.remove('hidden');
                    break;
                default:
                    break;
            }
            populateImageTesseraSocioModal(enableEtruriaCaptionOnModal);
            return coopId;
        }
        function enableStepRadios(stepId) {
            document.querySelectorAll(`#${stepId} input[type=radio]`).forEach(r => {
                r.disabled = false;
                if (r.classList.contains('mandatory'))
                    r.required = true;
            });
        }
        function disableStepRadios(stepId) {
            document.querySelectorAll(`#${stepId} input[type=radio]`).forEach(r => {
                r.disabled = true;
                r.required = false;
            });
        }
        function populateImageTesseraSocioModal(captionEtruriaEnabled) {
            let image = (document.getElementById("tessera_socio_image"));
            image.src = immagine_tessera_socio;
            let container_caption = document.querySelector(".coop-etruria-caption");
            if (captionEtruriaEnabled) {
                container_caption === null || container_caption === void 0 ? void 0 : container_caption.classList.remove('hidden');
            }
        }
        function logOut() {
            delete_cookie('session_token');
            delete_cookie('session_email');
            delete_cookie('session_coopId');
            delete_cookie('session_info');
            delete_cookie('event_info');
            delete_cookie('aperitivo');
            divLogNo.removeAttribute('hidden');
            divLogYes.setAttribute('hidden', '');
            if (window.location.pathname == '/area-riservata/il-mio-profilo')
                window.location.href = '/auth/login';
        }
        function delete_cookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
    });
})(profile || (profile = {}));
